import React from "react";
import {
  Button,
  Modal,
  PageHeader,
  PageTitle,
} from "../../../../../../../components";

const RollbackOffBoarding = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="ROLLBACK OFFBOARDING"
      width="max-w-3xl"
    >
      <PageHeader
        Section={
          <div className="mt-5">
            <PageTitle
              title={"Are you sure you want to Rollback Employee Offboarding ?"}
              icon={"info"}
              tag="p"
            />
          </div>
        }
      />
      <div className="flex gap-3 justify-end my-10">
        <Button title="No" variant="outlined" onClick={onClose} />
        <Button title="Yes" onClick={onClose} />
      </div>
    </Modal>
  );
};

export default RollbackOffBoarding;
